import Vue from 'vue';
import Algolia from '@/Algolia';
import InstantSearch from 'vue-instantsearch';
import { MediaQueries, CommonBands } from 'vue-media-queries';

const mediaQueries = new MediaQueries({
    bands: CommonBands.Tailwind
});

Vue.use(mediaQueries);

Vue.use(InstantSearch);

Vue.config.devtools = true;

// Normal search

const containers = document.querySelectorAll('.roam-search');
const dealscontainer = document.querySelector('.roam-deals-search');
const searchTemplate = dealscontainer ? '<Deals/>' : '<Algolia/>';

if (containers.length) {
    containers.forEach((container) => {
        new Vue({
            el: container,
            components: { Algolia },
            mixins: [CommonBands.Tailwind.mixin],
            data() {
                return {
                    categories: [
                        {
                            label: 'All',
                            value: ''
                        },
                        ...JSON.parse(container.dataset.categories)
                    ],
                    hub: container.dataset.hub
                };
            },
            template: searchTemplate,
            mediaQueries: mediaQueries
        });
    });
}
